import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { PARTNERSHIPS } from "../data/site";
import PageHero from "../components/common/PageHero";
import Reveal from "../components/common/Reveal";
import PartnerForm from "../components/forms/PartnerForm";
import useSeo from "../hooks/useSeo";

const typeMap = {
  "split-fee-partnership": "Recruitment Agency",
  "agency-partnership": "Recruitment Agency",
  "independent-recruiter-partnership": "Independent Recruiter",
  "referral-partnership": "Referral Partner",
  "candidate-exchange-partnership": "Candidate Exchange Partner",
  "international-recruitment-partnership": "International Recruitment Partner",
};

export default function PartnershipDetail() {
  const { slug } = useParams();
  const p = PARTNERSHIPS.find((x) => x.slug === slug);
  useSeo({
    title: p ? p.title : "Partnership",
    description: p ? p.summary : undefined,
  });
  if (!p) return <Navigate to="/partnerships" replace />;
  const Icon = p.icon;

  return (
    <>
      <PageHero overline="Partnership" title={p.title} description={p.summary} crumb={p.title} parentCrumb={{ label: "Strategic Alliances", to: "/partnerships" }} />
      <section className="py-20 lg:py-24">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <Reveal>
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-gold/10 text-gold">
              <Icon className="h-7 w-7" />
            </span>
            <p className="mt-6 text-lg leading-relaxed text-charcoal/80">{p.description}</p>
            <div className="mt-8 rounded-2xl border border-border bg-white p-6">
              <h4 className="font-serif text-lg text-navy">How we work together</h4>
              <ul className="mt-4 space-y-3 text-sm text-charcoal/80">
                <li>• Clear, pre-agreed terms confirmed in writing.</li>
                <li>• Transparent communication throughout the partnership.</li>
                <li>• Shared success built on trust and professionalism.</li>
                <li>• A long-term, relationship-led approach.</li>
              </ul>
            </div>
            <Link to="/partnerships" className="mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-gold">
              <ArrowLeft className="h-4 w-4" /> All partnerships
            </Link>
          </Reveal>
          <Reveal delay={100}>
            <div className="rounded-2xl border border-border bg-background p-6 shadow-sm sm:p-8">
              <h3 className="font-serif text-2xl text-navy">Become a Recruitment Partner</h3>
              <p className="mt-2 text-sm text-muted-foreground">Register your interest in this partnership.</p>
              <div className="mt-6">
                <PartnerForm defaultType={typeMap[slug]} />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
